export default __webpack_public_path__ + "static/media/ic-image-studio.9a12d8ea.svg";